//import axios to make request
import axios from "axios";

// get all zones from distributor
export async function getContainers({ commit }, payload) {
  try {
    const { data } = await axios.get("/container", {
      params: payload,
    });

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    throw Error(e.response.data.message);
  }
}

export async function generateQRlabels({ commit }, payload) {
  try {
    const { data } = await axios.post(
      "/container/generate-containers",
      payload
    );

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    throw Error(e.response.data.message);
  }
}

export async function regenerateQRlabels({ commit }, payload) {
  try {
    const { data } = await axios.post(
      "/container/regenerate-containers",
      payload
    );

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    throw Error(e.response.data.message);
  }
}
